import { render } from "./AposTiptapColor.vue?vue&type=template&id=9f0ef124&scoped=true"
import script from "./AposTiptapColor.vue?vue&type=script&setup=true&lang=js"
export * from "./AposTiptapColor.vue?vue&type=script&setup=true&lang=js"

import "./AposTiptapColor.vue?vue&type=style&index=0&id=9f0ef124&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0ef124"],['__file',"rich-text-widget/ui/apos/components/AposTiptapColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f0ef124"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f0ef124', __exports__)) {
    api.reload('9f0ef124', __exports__)
  }
  
  module.hot.accept("./AposTiptapColor.vue?vue&type=template&id=9f0ef124&scoped=true", () => {
    api.rerender('9f0ef124', render)
  })

}


export default __exports__